// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2360a7b9","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/views/Order/orderDes.vue
// module id = 434
// module chunks = 0